<ng-content select="[start]" />

<ctx-content-thumbnail [size]="size()" [content]="content()" />

<div class="content-row__information">
	@if (label(); as label) {
		<small class="content-row__information-label m-0">
			{{ label }}
		</small>
	}

	<p class="m-0">
		{{ content().name }}
	</p>

	@if (asTableRow() && !label()) {
		<small class="m-0">
			{{
				'data.last-edited-at'
					| transloco: { time: content().updatedAt | relativeTime }
			}}
		</small>
	}
</div>

<div class="content-row__actions">
	@if (asTableRow()) {
		@if (showAccess()) {
			@if (isShared()) {
				<span
					tuiBadge
					class="content-row__actions-badge"
					appearance="info"
					iconStart="@tui.share-2"
					tuiHintAppearance="dark"
					[tuiHint]="'content.shared-access-description' | transloco"
				>
					<span class="content-row__actions-badge-text">
						{{ 'content.shared-access' | transloco }}
					</span>
				</span>
			} @else if (!isMine() && roleAccess()) {
				<span
					tuiBadge
					class="content-row__actions-badge"
					appearance="neutral"
					iconStart="@tui.circle-user"
					tuiHintAppearance="dark"
					[tuiHint]="
						'content.role-access-description'
							| transloco
								: { role: 'user.roles.' + role() | transloco }
					"
				>
					<span class="content-row__actions-badge-text">
						{{ 'content.role-access' | transloco }}
					</span>
				</span>
			}
		}

		@if (interactable()) {
			<tui-icon icon="@tui.arrow-right" />
		}
	} @else {
		<ng-content select="[end]" />
	}
</div>
